'use client'

import { useState } from 'react'
import clsx from 'clsx'
import { motion, AnimatePresence } from 'motion/react'
import { GrayscaleTransitionImage } from '@/components/GrayscaleTransitionImage'

function Tab({ isActive, children, onClick }) {
    return (
        <button
            onClick={onClick}
            type="button"
            className={clsx(
                'relative px-5 py-2 text-sm font-medium drop-shadow-sm transition-colors duration-200 focus:outline-none',
                isActive
                    ? 'text-white'
                    : 'text-white/70 hover:text-white',
            )}
        >
            {isActive && (
                <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 rounded-md bg-white/15 ring-1 ring-white/25"
                    transition={{ type: 'spring', bounce: 0.15, duration: 0.5 }}
                />
            )}
            <span className="relative z-10">{children}</span>
        </button>
    )
}

export function BeforeAfterToggle({ before, after }) {
    const [activeTab, setActiveTab] = useState('after') // Default to 'after' as the main view

    return (
        <div className="relative overflow-hidden group">
            <div className="absolute top-6 left-0 right-0 z-20 flex justify-center">
                <div className="flex rounded-lg bg-neutral-950/40 p-1 shadow-lg backdrop-blur-xl ring-1 ring-white/10">
                    <Tab
                        isActive={activeTab === 'before'}
                        onClick={() => setActiveTab('before')}
                    >
                        Before
                    </Tab>
                    <Tab
                        isActive={activeTab === 'after'}
                        onClick={() => setActiveTab('after')}
                    >
                        After
                    </Tab>
                </div>
            </div>

            <div className="relative">
                <AnimatePresence mode="popLayout" initial={false}>
                    {activeTab === 'before' ? (
                        <motion.div
                            key="before"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -20 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            className="w-full"
                        >
                            <GrayscaleTransitionImage
                                {...before}
                                quality={90}
                                className="w-full"
                                sizes="(min-width: 1216px) 76rem, 100vw"
                                priority
                            />
                        </motion.div>
                    ) : (
                        <motion.div
                            key="after"
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                            className="w-full"
                        >
                            <GrayscaleTransitionImage
                                {...after}
                                quality={90}
                                className="w-full"
                                sizes="(min-width: 1216px) 76rem, 100vw"
                                priority
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    )
}
